/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="85.97"
        height="95.45"
        viewBox="0 0 85.97 95.45"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.93.32a1.24 1.24 0 0 1 1.67 0C50.8 9.5 62.99 14.05 78.32 14.5a1.25 1.25 0 0 1 1.2 1.12v16.44l-.02 1.44v1.62a1.24 1.24 0 0 1-1.28 1.22A1.27 1.27 0 0 1 77 35.05l.05-1.71V16.96h-.27c-14.72-.7-26.71-5.21-36.82-13.89l-.18-.15-.17.15C29.5 11.74 17.5 16.25 2.77 16.95H2.5v17.21c.21 13.14 1.81 22.92 5.81 31.68l.24.52c5.56 11.87 15.44 20.7 30.93 26.42l.25.09.46-.17a68.45 68.45 0 0 0 11.78-5.62l.69-.42a1.251 1.251 0 1 1 1.33 2.12 71.82 71.82 0 0 1-13.83 6.6 1.37 1.37 0 0 1-.85 0c-16.5-5.93-27.09-15.3-33-28C2.3 58.86.5 49.5.1 37.29V15.76a1.25 1.25 0 0 1 1.11-1.26c15.29-.45 27.52-5 37.72-14.18Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M63.16 44.19a1.27 1.27 0 0 1 1.25 1.13v12.8H77.3a1.26 1.26 0 0 1 1.25 1.12v.13a1.24 1.24 0 0 1-1.12 1.24H63.16a1.24 1.24 0 0 1-1.24-1.11V45.44a1.25 1.25 0 0 1 1.24-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M69.16 74.35a1.25 1.25 0 0 1 2.2 1.18l-.06.12-3.7 6.1a1.253 1.253 0 0 1-2.21-1.18l.11-.07Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M65.34 80.72a1.26 1.26 0 0 1 1.45-.84h.12l6.91 2.18a1.25 1.25 0 0 1-.63 2.42h-.12l-6.91-2.19a1.25 1.25 0 0 1-.82-1.57Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M65.82 37.5a1.26 1.26 0 0 1 1.47-1 23.28 23.28 0 0 1-.55 45.74 1.25 1.25 0 1 1-.43-2.46 20.78 20.78 0 0 0 .49-40.83 1.24 1.24 0 0 1-.98-1.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M40.73 61.44a1.24 1.24 0 0 1 1.42 1 20.82 20.82 0 0 0 17.69 17.45 1.252 1.252 0 0 1-.35 2.48 23.31 23.31 0 0 1-19.81-19.51 1.24 1.24 0 0 1 1.05-1.42ZM60.08 36.3a1.25 1.25 0 1 1 .29 2.48 20.54 20.54 0 0 0-18.15 17.51 1.25 1.25 0 1 1-2.47-.38A23 23 0 0 1 60.08 36.3Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithClock180ArrowIcon';

export default Icon;
